import React from 'react';
interface ProgressRingProps {
  progress: number;
  size?: number;
  strokeWidth?: number;
  color?: string;
  trackColor?: string;
}
export function ProgressRing({
  progress,
  size = 60,
  strokeWidth = 5,
  color = 'text-blue-600',
  trackColor = 'text-gray-100'
}: ProgressRingProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - progress / 100 * circumference;
  return <div className="relative inline-flex items-center justify-center" data-id="element-174">
      <svg className="transform -rotate-90" width={size} height={size} data-id="element-175">
        <circle className={trackColor} stroke="currentColor" strokeWidth={strokeWidth} fill="transparent" r={radius} cx={size / 2} cy={size / 2} data-id="element-176" />
        <circle className={`${color} transition-all duration-1000 ease-out`} stroke="currentColor" strokeWidth={strokeWidth} strokeDasharray={circumference} strokeDashoffset={offset} strokeLinecap="round" fill="transparent" r={radius} cx={size / 2} cy={size / 2} data-id="element-177" />
      </svg>
      <span className="absolute text-xs font-bold text-gray-700 tabular-nums" data-id="element-178">
        {progress}%
      </span>
    </div>;
}